import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/auth";

export default function Volunteers() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/ops/volunteers").then((r) => setItems(r.data.items || [])).catch((e) => setErr(formatApiErrorDetail(e?.response?.data?.detail)));
  }, []);
  return (
    <div className="space-y-4" data-testid="ops-volunteers-page">
      <h1 className="text-2xl font-semibold text-slate-900">Active volunteers</h1>
      {err && <div className="text-sm text-red-700">{err}</div>}
      <div className="bg-white rounded-xl border overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead className="bg-slate-50 text-slate-500"><tr><th className="text-left px-4 py-2">Name</th><th className="text-left px-4 py-2">Email</th><th className="text-left px-4 py-2">Location</th><th className="text-left px-4 py-2">Interests</th><th className="text-left px-4 py-2">Activated</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-center text-slate-500">No active volunteers yet.</td></tr>}
            {items.map((v) => (
              <tr key={v.id} className="border-t" data-testid="ops-volunteer-row">
                <td className="px-4 py-3 text-slate-900">{v.name}</td>
                <td className="px-4 py-3">{v.email}</td>
                <td className="px-4 py-3">{v.location || "—"}</td>
                <td className="px-4 py-3">{(v.interests || []).join(", ") || "—"}</td>
                <td className="px-4 py-3 text-slate-500">{(v.activated_at || "").slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
